/* eslint-disable no-unused-vars */
import React from 'react';

export const BuyItAgainItemContext = React.createContext({
  orderNumber: undefined,
  item: undefined,
  selectedPricedQuantity: undefined,
  setSelectedPricedQuantity: selectedPricedQuantity => {},
  currencyCode: undefined,
  fractionDigits: undefined,
});
